import Tooltip from '@anm/components/Tooltip';
import formatTimeWithAliases from '@anm/helpers/time/formatTimeWithAliases';
import { InfoLabel } from '@anm/styles/helpers';
import { useCallback, useRef, FC } from 'react';
import { useSelector } from 'react-redux';

import { CHART_BAR_MARGIN_RIGHT } from '..';
import { analyticsSelectors } from '../../../../../../store/modules/analytics';
import { projectSelectors } from '../../../../../../store/modules/project';
import { ChartTitle, ChartTitleWrapper, TitleRow } from '../Wrapper';
import { useHeaderMaxWidth } from '../hooks';
import { AnalyticsTabProps } from '../types';

import Content from './Content';
import Wrapper from './Wrapper';

const TotalPlayPlayerChart: FC<AnalyticsTabProps> = props => {
  const totalTimePlayedChartRef = useRef<HTMLDivElement>(null);
  const containerWidth = useHeaderMaxWidth(
    totalTimePlayedChartRef,
    CHART_BAR_MARGIN_RIGHT
  );
  const totalTimePlayedData = useSelector(state =>
    analyticsSelectors.selectAggregateValueByKey(state, 'timePlayed')
  );
  const isProjectEverRender = useSelector(
    projectSelectors.selectCurrentProjectEverRendered
  );

  const renderTooltipContent = useCallback(
    () => (
      <span>
        How many hours your <br />
        video was played.
      </span>
    ),
    []
  );

  const isTotalTimePlayed = !!totalTimePlayedData && isProjectEverRender;

  return (
    <Wrapper ref={totalTimePlayedChartRef}>
      <TitleRow maxWidth={containerWidth}>
        <ChartTitleWrapper>
          <ChartTitle title="Total time played" level={4} />
          <Tooltip direction="to-top" renderContent={renderTooltipContent}>
            <InfoLabel />
          </Tooltip>
        </ChartTitleWrapper>
        {isTotalTimePlayed && (
          <span>{formatTimeWithAliases(totalTimePlayedData!)}</span>
        )}
      </TitleRow>
      <Content
        maxWidth={containerWidth}
        containerRef={totalTimePlayedChartRef}
        {...props}
      />
    </Wrapper>
  );
};

export default TotalPlayPlayerChart;
